module.exports = __webpack_public_path__ + "img/horizontal_5_1_3016.681831a1.png";